module.exports = __webpack_public_path__ + "img/IT0000382218916.f6544a84.png";